import React from 'react';
import {ButtonGroup} from 'react-bootstrap';

import './common.css';

const TooltipButtonGroup = props => (
  <ButtonGroup>
    {React.Children.map(props.children, (button, i) => {
      let len = React.Children.count(props.children);
      if (i === 0 && i === len - 1)
        return button;
      let className = button.props.className !== undefined ? button.props.className : '';
      if (i !== 0)
      {
        if (className.length > 0)
          className += ' ';
        className = 'notFirstGroupButton';
      }
      if (i !== len - 1)
      {
        if (className.length > 0)
          className += ' ';
        className += 'notLastGroupButton';
      }
      return React.cloneElement(button, {className});
    })}
  </ButtonGroup>
);

export default TooltipButtonGroup;



// WEBPACK FOOTER //
// ./src/components/tooltipButtonGroup.js